export default class TrackEvent {
  constructor(context) {
    this.context = context;
  }

  run({ event, props }) {
    this.context.analytics.track(event, props);
  }
}
